import { Injectable } from "@angular/core";
import { environment } from "@/environments/environment";
import { AuthenticateApi } from "@/api/authenticate.api";
import { Claims, JwtTokenData, Token } from "@/models/token.model";
import { Router } from "@angular/router";
import { JwtService } from "./jwt.service";

@Injectable({
  providedIn: "root",
})
export class SessionService {
  constructor(
    private authenticateApi: AuthenticateApi,
    private router: Router,
    private jwtService: JwtService
  ) {}

  public async login(email: string, password: string): Promise<Token> {
    const token = await this.authenticateApi.login(email, password);
    if (token) {
      this.setToken(token);
    }
    return token;
  }

  public async confirmEmail(userId: string, token: string): Promise<void> {
    await this.authenticateApi.confirmEmail(userId, token);
  }

  public getUserToken(): JwtTokenData | null {
    const token = this.getToken();
    if (token) {
      return this.jwtService.decodeToken(token.accessToken) as JwtTokenData;
    }
    return null;
  }

  public setToken(token: Token): void {
    if (token) {
      localStorage.setItem(environment.sessionKey, JSON.stringify(token));
    } else {
      localStorage.removeItem(environment.sessionKey);
    }
  }

  public async sendEmailForgotPassword(email: string): Promise<void> {
    await this.authenticateApi.forgotPassword(email);
  }

  public getToken(): Token | null {
    const t = localStorage.getItem(environment.sessionKey) || "";
    return t !== "" ? (JSON.parse(t) as Token) : null;
  }

  public hasPermission(name: string): boolean {
    const userClaims = this.getClaims();
    return (
      userClaims?.some(
        (claim) =>
          claim.type.toLowerCase() === "permission" &&
          claim.value.toLowerCase() === name.toLowerCase()
      ) ?? false
    );
  }

  public getClaims(): Claims[] | null {
    const t = localStorage.getItem(environment.sessionKey) || "";
    return t !== "" ? (JSON.parse(t) as Token).userToken.claims : null;
  }

  public Logged(): boolean {
    const t = localStorage.getItem(environment.sessionKey) || "";
    if (t === "" || t === null || typeof t === "undefined") {
      return false;
    }
    return true;
  }

  public loggedUser(): any {
    const userToken = this.getToken()?.userToken;
    const loggedUser = {
      userName: userToken?.name,
      email: userToken?.email,
    };
    return loggedUser;
  }

  public removeToken(): void {
    localStorage.removeItem(environment.sessionKey);
  }

  logout() {
    //this.authenticateApi.logout();
    localStorage.clear();
    this.router.navigateByUrl("/auth/login");
  }
}
